import { Controller } from '@hotwired/stimulus';

export default class NoPasteController extends Controller {
  connect() {
    this.element.addEventListener('paste', handler);
  }

  disconnect() {
    this.element.removeEventListener('paste', handler);
  }
}

const handler = (event) => {
  event.preventDefault();
  return false;
}
